import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => props.theme.colors.background.secondary};
  padding: ${props => props.theme.spacing.sp8};
  border-radius: ${props => props.theme.primitives.radius.radius1};
`

export const TotalsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp4};
  align-items: center;
  margin-right: ${props => props.theme.spacing.sp24};

  p {
    text-align: right;
  }
`
